/**
 * Created by Pactera on 2017/4/14.
 * 退改申请页面
 */
import Routes from 'Routes';
import { saveOldLocation } from '../../modules/actions';
import { gspNewVersion, isCsairApp } from '@csair/emp-helpers';
import { clearCoupon } from '../coupon/modules/actions';
import { clearRefundCoupon } from '../refundCoupon/modules/actions';
import { loadStatusCodeMsg } from 'enEXchange';

export default store => ({
  path: Routes.ticket.child.endorsedApply.key,
  onEnter(nextState, replace, callback) {
    loadStatusCodeMsg(
      ['checkOrderTicket', 'checkTicketFlight', 'cancelCheckIn'],
      {
        cancelCheckIn: [],
      }
    );
    window.localStorage.removeItem('routeType');
    window.sessionStorage.removeItem('pageButtonName');
    // gspCollect(
    //   [
    //     '2021-EMP退改-选航段选旅客页面',
    //     '选航段选旅客页面',
    //     '004-000-71001-103',
    //   ],
    //   { 6: '国内' },
    //   process.env.NODE_ENV === 'production'
    // );
    const { ticketChangeType, channel } = nextState.location.query;

    gspNewVersion(
      ticketChangeType === 'refundTicket'
        ? ['退票-填写信息页面', '072-0046-23028-12201']
        : ['变更-填写信息页面', '072-0017-23028-12201'],
      {
        1: '页面曝光一次触发一次',
        2: '国双新版',
        3: isCsairApp() ? 'App' : 'Mobile',
      }
    );
    let pageName =
      ticketChangeType === 'refundTicket'
        ? channel === 'TPWL'
          ? '机票退改-取消行程选人选航段页'
          : '机票退改-退票选人选航段页'
        : '机票退改-变更选人选航段页';
    window.$sensors.sensors.track('flight_ticket_refund_and_change_page_view', {
      page_name: pageName,
      channel_id: channel ? channel : '',
    });

    store.dispatch(clearCoupon());
    store.dispatch(clearRefundCoupon());
    callback();
  },
  onLeave(prevState) {
    store.dispatch(saveOldLocation(prevState.location));
  },
  getComponent(nextState, cb) {
    require.ensure(
      [],
      require => {
        const EndorsedApply = require('./components/EndorsedApply').default;
        cb(null, EndorsedApply);
      },
      'endorsedApply'
    );
  },
});



// WEBPACK FOOTER //
// ./src/routes/routes/endorsedApply/index.js